
<!-- <a href="javascript:;"
   routerLink="/recruitement-candidate-details/{{openingId}}"> 
    <img src="./assets/media/svg/icons/General/dashboard.svg" title="Dashboard">

    
</a> -->
<img src="./assets/media/svg/icons/General/Edit-3.svg" (click)="updateRecruiterMethod()">
&nbsp;
<img src="./assets/media/svg/icons/General/dashboard.svg" (click)="openPositionDetailsPage()">